import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ImportantMessage from './ImportantMessage';
import { updateCSSVar } from '../../utils/cssVarsUtil';
import { useLocalStorage } from '../../hooks/useLocalStorage';
import { StyledImportantMessagesContainer } from './ImportantMessage.styles';

const MESSAGE_HEIGHT = 75;

const getCombinedId = (message) =>
    message.id ? `${message.id}-${message.updated}-${message.created}` : undefined;

const ImportantMessages = ({ hasCookie, messages = [] }) => {
    const [read, setRead] = useLocalStorage('readImportantMessage', {});
    const readMessages = Object.keys(read);

    // TODO: can this be removed?
    useEffect(() => {
        const undReadMessages = messages.filter((message) => !readMessages.includes(getCombinedId(message)));

        updateCSSVar('important-messages-height', `${undReadMessages.length * MESSAGE_HEIGHT}px`);
    }, [messages, readMessages]);

    const handleOnClose = (combinedId) => {
        const newValue = { ...read, [combinedId]: true };
        setRead(newValue);
    };

    if (!messages || messages.length === 0) {
        return null;
    }

    return (
        <StyledImportantMessagesContainer id="important-messages" role="complementary">
            {messages.map((message, index) => {
                const id = getCombinedId(message);
                const isRead = id ? readMessages.includes(id) : false;

                return (
                    <ImportantMessage
                        key={index}
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...message}
                        combinedId={getCombinedId(message)}
                        isRead={isRead}
                        onClose={handleOnClose}
                        hasCookie={hasCookie}
                    />
                );
            })}
        </StyledImportantMessagesContainer>
    );
};

ImportantMessages.propTypes = {
    messages: PropTypes.array,
};

export default ImportantMessages;
